import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Компонент для маршрутизации на основе ролей
 * @param {Object} props
 * @param {React.ReactNode} props.children - Дочерние компоненты
 * @param {string[]} props.requiredRoles - Список ролей, которым разрешен доступ
 * @param {string[]} props.excludeRoles - Список ролей, которым запрещен доступ
 * @param {string} props.redirectTo - URL для редиректа при отсутствии доступа
 */
const RoleBasedRoute = ({ 
  children, 
  requiredRoles = [], 
  excludeRoles = [], 
  redirectTo = '/' 
}) => {
  const { isAuthenticated, userRole, loading } = useAuth();

  if (loading) {
    return <div className="loading-spinner">Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Проверка на исключенные роли
  if (excludeRoles.length > 0 && excludeRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Проверка на требуемые роли
  if (requiredRoles.length > 0 && !requiredRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;